// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"779":"catalog-frontend-vendors","965":"host"}[chunkId] + "." + {"779":"262213cd","965":"27b93688"}[chunkId] + ".min.css";
};